import { api } from "./client.js";

export type Level = "exact" | "city" | "country" | "hidden";

export interface MyOrg {
  id: string;
  slug: string;
  name: string;
  visibility_ceiling: Level;
  allowed_domains: string;
}
export interface OrgMember {
  id: string;
  name: string;
  handle: string | null;
  role: string;
}
export interface Team {
  id: string;
  org_id: string;
  name: string;
}
export interface OrgDetail {
  org: {
    id: string;
    slug: string;
    name: string;
    allowed_domains: string;
    visibility_ceiling: Level;
  };
  members: OrgMember[];
  teams: Team[];
}

export const orgsApi = {
  create: (name: string, allowed_domains: string, visibility_ceiling: Level) =>
    api.post<{ id: string; slug: string }>("/api/orgs", {
      name,
      allowed_domains,
      visibility_ceiling,
    }),
  listMine: () => api.get<{ orgs: MyOrg[] }>("/api/orgs"),
  detail: (slug: string) => api.get<OrgDetail>(`/api/orgs/${slug}`),
  join: (slug: string) => api.post<{ joined: boolean }>(`/api/orgs/${slug}/join`),
  patch: (
    slug: string,
    body: { allowed_domains?: string; visibility_ceiling?: Level; name?: string },
  ) => api.patch<{ updated: boolean }>(`/api/orgs/${slug}`, body),
  removeMember: (slug: string, userId: string) =>
    api.del<{ removed: boolean }>(`/api/orgs/${slug}/members/${userId}`),
  teamsList: (orgId: string) => api.get<{ teams: Team[] }>(`/api/teams?org_id=${orgId}`),
  teamCreate: (orgId: string, name: string) =>
    api.post<{ id: string }>("/api/teams", { org_id: orgId, name }),
  teamDelete: (id: string) => api.del<{ deleted: boolean }>(`/api/teams/${id}`),
};
